import { formatDateTime } from '../../../utils/formatUtils';

const UUID_SEGMENT_PATTERN = /[0-9a-f]{6,}(?:-[0-9a-f]{3,}){2,4}/gi;
const UUID_FULL_PATTERN = /^[0-9a-f]{6,}(?:-[0-9a-f]{3,}){2,4}$/i;
const USING_ENDPOINT_PATTERN = /\s+usando\s+[A-Z]+\s+\/[^\s]+/gi;
const CONTRACT_ID_PATTERN = /contrato\s+id=(\d+)/gi;
const GENERIC_ID_PATTERN = /\bid=([0-9a-f-]{4,})/gi;

const sanitizeAuditText = (value) => {
  if (!value) return '';

  let text = String(value).trim();
  if (!text) return '';

  text = text.replace(USING_ENDPOINT_PATTERN, '');
  text = text.replace(CONTRACT_ID_PATTERN, 'contrato N° $1');
  text = text.replace(GENERIC_ID_PATTERN, (_match, idValue) => {
    if (!idValue) return '';
    if (UUID_FULL_PATTERN.test(idValue)) return '';
    return `N° ${idValue}`;
  });
  text = text.replace(UUID_SEGMENT_PATTERN, '');
  text = text.replace(/\s{2,}/g, ' ').trim();

  return text;
};

const maskUuidsInPath = (value) => {
  if (!value) return '';
  return String(value).replace(UUID_SEGMENT_PATTERN, ':id');
};

export const formatAuditTimestamp = (timestamp) => {
  if (!timestamp) return '';
  return formatDateTime(timestamp, { options: { dateStyle: 'short', timeStyle: 'medium' }, fallback: timestamp });
};

export const formatAuditUser = (action) => {
  if (!action) return 'Desconocido';
  if (action.user_names) return action.user_names;
  if (action.user_email) return action.user_email;
  return 'Desconocido';
};

export const formatRequestPath = (path, endpoint) => {
  if (path) return maskUuidsInPath(path);
  return maskUuidsInPath(endpoint || '');
};

export const formatHttpMethod = (method) => (method ? method.toUpperCase() : '');

export const formatAuditDescription = (action) => {
  const description = action?.description;
  if (description && String(description).trim()) {
    const sanitized = sanitizeAuditText(description);
    if (sanitized) return sanitized;
  }

  const method = formatHttpMethod(action?.http_method);
  const path = formatRequestPath(action?.request_path, action?.endpoint);
  const moduleName = action?.module?.display_name || action?.module?.key || 'Módulo';

  if (method && path) return `${method} ${path}`.trim();
  if (path) return path.trim();
  return `Acción registrada en ${moduleName}`;
};

export const formatTechnicalAuditLine = (action) => {
  const method = formatHttpMethod(action?.http_method);
  const path = formatRequestPath(action?.request_path, action?.endpoint);

  if (method && path) return `${method} ${path}`;
  if (path) return path;
  return 'Sin endpoint registrado';
};

export const getStatusColor = (statusCode) => {
  if (!statusCode) return 'default';
  if (statusCode >= 200 && statusCode < 300) return 'success';
  if (statusCode >= 300 && statusCode < 500) return 'warning';
  return 'error';
};
